import React from 'react';
import './PageStyles.css';

function Contact() {
  return (
    <div className="page">
      <h1>Contact Us</h1>

      <p style={{ fontSize: '18px', fontWeight: '500' }}>
        We’re here to guide you. Whether it’s a query, feedback, or support — feel free to connect with us anytime!
      </p>

      <h2 style={{ marginTop: '30px' }}>📧 Email Support</h2>
      <p>
        <a href="mailto:testyodha3@gmail.com" style={{ color: '#0047ab' }}>
            testyodha3@gmail.com
          </a>
      </p>

      <h2>📞 Phone</h2>
      <p>+91 70604 18100</p>

      <h2>📍 Address</h2>
      <p>
        Nagla Mahour, Rithori Karta,<br />
        Agra, Uttar Pradesh – 283124
      </p>

      <h2>📺 YouTube</h2>
      <p>
        <a href="https://www.youtube.com/@faujdardefenceacademy723" target="_blank" rel="noreferrer" style={{ color:'#0047ab'}}>
          @faujdardefenceacademy723
        </a>
      </p>

      <hr style={{ margin: '40px auto', width: '60%', borderColor: '#444' }} />
<p style={{ fontStyle: 'italic', color: '#25292e' }}>
        We're available for aspirants or students anytime. Reach out via email or phone — we typically respond within 24 hours.
        <br />
        Your growth is our mission. Let’s build success together 🚀
      </p>
    </div>
  );
}

export default Contact;